import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../LoadingSpinner';
import EditableImageRow from './EditableImageRow'; // Import the new component

const API_DOMAIN = "https://test-api.stainedglassusa.com";

function AdminImageEditor() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fetchError, setFetchError] = useState(null); // Separate error for initial fetch

  // Function to update a single image in the state array
  const handleImageUpdateSuccess = (updatedImage) => {
    setImages(currentImages =>
      currentImages.map(img => (img.id === updatedImage.id ? updatedImage : img))
    );
  };

  // Fetch images when component mounts
  useEffect(() => {
    const token = localStorage.getItem('token');
    setLoading(true);
    setFetchError(null); // Clear fetch error on new attempt

    fetch(`${API_DOMAIN}/admin/images`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(res => {
        if (!res.ok) {
          // Prioritize specific error messages
          if (res.status === 401 || res.status === 403) {
            throw new Error(`Unauthorized (${res.status}): Access Denied`);
          }
          // Try to include response text for better debugging
          return res.text().then(text => {
            throw new Error(`HTTP Error ${res.status}: ${res.statusText}. Response: ${text.substring(0, 100)}...`);
          });
        }
        return res.json();
      })
      .then(data => {
        if (Array.isArray(data)) {
           setImages(data);
        } else {
           console.error("API response is not an array:", data);
           throw new Error("Received invalid data format from server.");
        }
      })
      .catch(err => {
        console.error("Admin Fetch Error:", err);
        if (err instanceof SyntaxError) {
          setFetchError("Failed to parse server response. Expected JSON.");
        } else {
          setFetchError(err.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // === Render Logic ===

  if (loading) {
    return <LoadingSpinner />;
  }

  // Use specific fetch error for initial load problem
  if (fetchError) {
    return <div style={{ color: 'red', padding: '20px' }}>Error loading images: {fetchError}</div>;
  }

  return (
    <div style={{ padding: '20px' }}>
      <h1>Edit Base Images (Admin)</h1>
      <p>Found {images.length} image patterns.</p>

      <table className="admin-image-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ borderBottom: '2px solid black' }}>
            <th style={{ textAlign: 'left', padding: '8px' }}>ID</th>
            <th style={{ textAlign: 'left', padding: '8px' }}>Preview</th>
            <th style={{ textAlign: 'left', padding: '8px' }}>Title</th>
            <th style={{ textAlign: 'left', padding: '8px' }}>Parent Name</th>
            <th style={{ textAlign: 'center', padding: '8px' }}>Featured?</th>
            <th style={{ textAlign: 'center', padding: '8px' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {images.length === 0 ? (
            <tr><td colSpan="6" style={{ textAlign: 'center', padding: '16px' }}>No images found.</td></tr>
          ) : (
            // Use the new EditableImageRow component
            images.map(image => (
              <EditableImageRow
                key={image.id}
                image={image}
                token={localStorage.getItem('token')} // Pass token down
                onUpdateSuccess={handleImageUpdateSuccess} // Pass update handler
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default AdminImageEditor;
